import React, { Component } from 'react';
import { BreakpointProvider } from 'react-socks';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './reducers';

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { encryptTransform } from 'redux-persist-transform-encrypt'

import './styles/App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './AppRouter'

import { PersistGate } from 'redux-persist/integration/react'
import { syncI18nLanguage } from './localize/i18n'

const encryptor = encryptTransform({
  secretKey: '#my@-super@-secret-!key#',
  onError: function (error) {
    persistor.purge()
  }
})

// Generate unique key for QR codes to prevent table data mixing
const pathSegments = window.location.pathname.split('/');
const persistKey = pathSegments[1] === 'qr' && pathSegments[2] 
  ? `${pathSegments[1]}-${pathSegments[2]}` // Use full QR code ID for unique storage
  : pathSegments[1] || 'root';

const persistConfig = {
  key: persistKey,
  storage,
  transforms: [encryptor]
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const persistor = persistStore(store)

class App extends Component {
  render() {
    return (
      <Router>
        <Provider store={store}>
          <PersistGate
            loading={null}
            persistor={persistor}
            // La langue persistée (par restaurant) reste la référence : i18next est aligné dessus après réhydratation
            onBeforeLift={() => syncI18nLanguage(store.getState().settings.lang)}
          >
            <BreakpointProvider>
              <AppRouter />
            </BreakpointProvider>
          </PersistGate>
        </Provider>
      </Router>
    );
  }
}

export default App;
